import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  FlexRow,
  HashLength,
  SvgIcon,
  VerifiedIcon,
} from '@make-software/cspr-design';

import { AccountInfoAffiliatedAccount } from '@block-explorer/entities';
import {
  AccountInfoAccordion,
  AccountInfoTable,
} from '../account-info-accordion/account-info-accordion';
import { deriveAccountInfo, isValidPublicKey } from '../../utils/account';
import DetailsTableRow from '../details-table-row/details-table-row';
import DetailsNameTableData from '../details-name-table-data/details-name-table-data';
import DetailsValueTableData from '../details-value-table-data/details-value-table-data';
import {
  HashFontSize,
  TableDataAccountInfo,
} from '../table-data-account-info/table-data-account-info';
import { useCreateAccountsInfoGetter } from '../../hooks';

export const DetailsAccordionAffiliatedAccounts = ({
  accordionTitle,
  affiliated_accounts,
  isAccountVerified,
}: {
  accordionTitle: React.ReactElement;
  affiliated_accounts?: AccountInfoAffiliatedAccount[];
  isAccountVerified;
}) => {
  const { t } = useTranslation();

  const accountsEmpty =
    affiliated_accounts == null ||
    affiliated_accounts.filter((i) => isValidPublicKey(i.public_key)).length ===
      0;

  const publicKeysList = accountsEmpty
    ? null
    : affiliated_accounts.map((i) => i.public_key);

  const { getAccountInfo, loading: loadingAccountsInfo } =
    useCreateAccountsInfoGetter(publicKeysList);

  return accountsEmpty ? null : (
    <AccountInfoAccordion
      disableClickAway
      renderContent={() => (
        <AccountInfoTable
          renderData={() => (
            <>
              {affiliated_accounts
                ?.filter((i) => isValidPublicKey(i.public_key))
                .map((i, index) => {
                  const publicKey: string = i.public_key!;
                  const accountInfo = getAccountInfo(i.public_key);
                  const csprName = accountInfo?.cspr_name;
                  const accountInfoData = deriveAccountInfo(
                    accountInfo?.account_info ||
                      accountInfo?.centralized_account_info
                  );
                  const logo = accountInfoData?.logo;
                  return (
                    <DetailsTableRow key={publicKey}>
                      <DetailsNameTableData>
                        <Trans t={t}>Account</Trans> {index + 1}
                      </DetailsNameTableData>
                      <DetailsValueTableData monotype>
                        <FlexRow align={'center'}>
                          <TableDataAccountInfo
                            loading={loadingAccountsInfo}
                            publicKey={publicKey}
                            hashLength={HashLength.FULL}
                            csprName={csprName}
                            copyNotifyingStyle={'full'}
                            avatarSize={'small'}
                            hashFontSize={HashFontSize.big}
                            logo={logo}
                          />
                          {isAccountVerified(publicKey) && (
                            <SvgIcon
                              src={VerifiedIcon}
                              role={'img'}
                              alt={'Verified icon'}
                              marginLeft
                            />
                          )}
                        </FlexRow>
                      </DetailsValueTableData>
                    </DetailsTableRow>
                  );
                })}
            </>
          )}
        />
      )}
    >
      {accordionTitle}
    </AccountInfoAccordion>
  );
};
